import { AuthenticateDto, AuthenticateFromCodeDto, AuthenticateFromMaslDto, ChangePasswordDto, EidDataRecordDto, ParametresAzureDto, ParametresEmailDto, ParametresGlobauxDto, ParametresGoogleDto, ParametresJokerDto, ParametresRepresentantDto, SetPasswordWithTokenRequestDto, TokenDto } from 'src/api/models';

export namespace ControlPanel {

    export class Loading {
        static readonly type = '[ControlPanel] Loading';
    }

    export class StopLoading {
        static readonly type = '[ControlPanel] Stop loading';
    }

    export class Login {
        static readonly type = '[ControlPanel] Login';
        constructor(public authenticateDto: AuthenticateDto) { }
    }

    export class LoginFromCode {
        static readonly type = '[ControlPanel] Login from code';
        constructor(public authenticateFromCodeDto: AuthenticateFromCodeDto) { }
    }

    export class LoginPP {
      static readonly type = '[ControlPanel] Login physical person';
      constructor(public authenticateDto: AuthenticateDto) { }
    }

    export class LoginFromMSAL {
        static readonly type = '[Controlpanel] Login from Azure MSAL'
        constructor(public authenticateFromMsalDto: AuthenticateFromMaslDto) {}
    }

    export class LoginRedirect {
      static readonly type = '[ControlPanel] Login redirect';
      constructor() { }
    }

    export class Logout {
        static readonly type = '[ControlPanel] Logout';
    }

    export class SetToken {
      static readonly type = '[ControlPanel] Set token';
      constructor(public token: string) {}
    }

    export class ResetPassword {
        static readonly type = '[ControlPanel] Reset password';
        constructor(public token: string, public newPassword: string) { }
    }

    export class ResetPasswordPersonnePhysique {
      static readonly type = '[ControlPanel] Reset password for a physical person';
      constructor(public token: string, public newPassword: string) { }
    }

    export class PasswordForgotten {
        static readonly type = '[ControlPanel] Password forgotten';
        constructor(public email: string) { }
    }

    export class ChangePersonnePhysiquePassword {
      static readonly type = '[ControlPanel] Change Password for a physical person';
      constructor(public login: string, public changePasswordDto: ChangePasswordDto) { }
    }

    export class GetUserProfile {
        static readonly type = '[ControlPanel] Get user profile';
    }

    export class GetNavigationMenu {
        static readonly type = '[ControlPanel] Get navigation menu';
    }

    export class GetAllParams {
        static readonly type = '[ControlPanel] Get all params';
    }

    export class GetGlobalParams {
        static readonly type = '[ControlPanel] Get global params';
    }

    export class UpdateGlobalParams {
        static readonly type = '[ControlPanel] Update global params';
        constructor(public params: ParametresGlobauxDto) { }
    }

    export class GetEmailParams {
        static readonly type = '[ControlPanel] Get email params';
    }

    export class UpdateEmailParams {
        static readonly type = '[ControlPanel] Update email params';
        constructor(public params: ParametresEmailDto) { }
    }

    export class GetGoogleParams {
        static readonly type = '[ControlPanel] Get Google params';
    }

    export class UpdateGoogleParams {
        static readonly type = '[ControlPanel] Update Google params';
        constructor(public params: ParametresGoogleDto) { }
    }

    export class GetAzureParams {
        static readonly type = '[ControlPanel] Get Azure params';
    }

    export class UpdateAzureParams {
        static readonly type = '[ControlPanel] Update Azure params';
        constructor(public params: ParametresAzureDto) { }
    }

    export class GetJokerParams {
        static readonly type = '[ControlPanel] Get joker params';
    }

    export class UpdateJokerParams {
        static readonly type = '[ControlPanel] Update joker params';
        constructor(public params: ParametresJokerDto) { }
    }

    export class GetRepresentantParams {
      static readonly type = '[ControlPanel] Get representant params';
    }

    export class UpdateRepresentantParams {
        static readonly type = '[ControlPanel] Update representant params';
        constructor(public params: ParametresRepresentantDto) { }
    }

    export class GetLogo {
        static readonly type = '[ControlPanel] Get logo';
        constructor() { }
    }

    export class GetCodesPostaux {
        static readonly type = '[ControlPanel] Get codes postaux';
        constructor() { }
    }

    export class GetCodesPostauxAcceptes {
        static readonly type = '[ControlPanel] Get codes postaux acceptes';
        constructor() { }
    }

    export class GetPays {
        static readonly type = '[ControlPanel] Get pays';
        constructor() { }
    }

    export class GetTypesIncidents {
        static readonly type = '[ControlPanel] Get types incidents';
        constructor() { }
    }


    export class GetTypesDechet {
        static readonly type = '[ControlPanel] Get types déchet';
        constructor() { }
    }

    export class GetTypesDechetRW {
        static readonly type = '[ControlPanel] Get types déchet RW';
        constructor() { }
    }

    export class GetUnitesMesure {
        static readonly type = '[ControlPanel] Get unités mesure';
        constructor() { }
    }

    export class GetParcs {
        static readonly type = '[ControlPanel] Get parcs';
        constructor() { }
    }

    export class GetExutoires {
      static readonly type = '[ControlPanel] Get exutoires';
      constructor() { }
    }

    export class GetConteneurs {
      static readonly type = '[ControlPanel] Get conteneurs';
      constructor() { }
    }

    export class GetConteneursMobiles {
      static readonly type = '[ControlPanel] Get conteneurs mobiles';
      constructor() { }
    }

    export class UpdateSignalRStatus {
        static readonly type = '[ControlPanel] Update signalR status';
        constructor(public status: boolean) { }
    }

    export class GetZonesGeographiques {
        static readonly type = '[ControlPanel] Get zones geographiques';
        constructor() { }
    }

    export class GetTypesConteneurs {
        static readonly type = '[ControlPanel] Get types conteneurs';
        constructor() { }
    }

    export class GetPictogrammes {
        static readonly type = '[ControlPanel] Get pictogrammes';
        constructor() { }
    }

    export class GetCategoriesDocuments {
      static readonly type = '[ControlPanel] Get categories documents';
      constructor() { }
    }

    export class GetRolePermissions {
        static readonly type = '[ControlPanel] Get permissions for role';
        constructor( public roleName: string) { }
      }

    export class GetTypesAcces {
        static readonly type = '[ControlPanel] Get types acces personnes morales';
    }

    export class GetFormesJuridiques {
        static readonly type = '[ControlPanel] Get formes juridiques';
    }

    export class GetTransporteurs {
      static readonly type = '[ControlPanel] Get transporteurs';
    }

    export class GetDispatchExutoires {
      static readonly type = '[ControlPanel] Get dispatch exutoires';
    }

    export class GetDispatchTransporteurs {
      static readonly type = '[ControlPanel] Get dispatch transporteurs';
    }

    export class GetEmplacements {
        static readonly type = '[ControlPanel] Get emplacements';
        constructor() { }
    }

    export class GetArticles {
        static readonly type = '[ControlPanel] Get articles';
        constructor() { }
    }

    export class GetUserParc {
        static readonly type = "[ControlPanel] Get current user parc infos";
        constructor(public parcId: number) {}
    }

    export class GetTypesEvacuations {
        static readonly type = "[ControlPanel] Get types evacuations";
    }

    export class GetThemes {
        static readonly type = '[ControlPanel] Get themes';
        constructor() { }
    }

    export class GetTypesElementsStock {
        static readonly type = '[ControlPanel] Get types elements stock';
        constructor() { }
    }

    export class GetUtilisateursEC {
        static readonly type = '[ControlPanel] Get utilisateurs EC';
        constructor() { }
    }
}
